import { AlbertineContributions } from "./AlbertineContributions";
import ServiceHours from "./ServiceHours";
import "./Settings.css";

const Settings = function Settings() {
    return (
        <div className="settings">
            <div className="settings__title">
                <h3>Settings</h3>
            </div>
            <div className="panel-container">
                <div className="panel settings__service-hours">
                    <ServiceHours />
                </div>
                <AlbertineContributions />
            </div>
        </div>
    );
};

export default Settings;
